// React
import { useCallback, useMemo } from "react";
// Helpers
import { compact, find, has, reduce } from "@mefisto/utils";

export const useAction = (actions = []) => {
  // Memo
  const actionMap = useMemo(() => {
    return reduce(
      compact(actions),
      (result, action) => {
        result[action] = true;
        return result;
      },
      {}
    );
  }, [actions]);
  // Callback
  const hasAction = useCallback(
    (...actions) => {
      return !!find(actions, (action) => has(actionMap, action));
    },
    [actionMap]
  );
  // Render
  return {
    action: hasAction,
    a: hasAction,
  };
};
